module.exports = __webpack_public_path__ + "img/3.572b05de.jpg";